import { render } from "./FatherBreederInput.vue?vue&type=template&id=059b1228&scoped=true"
import script from "./FatherBreederInput.vue?vue&type=script&lang=js"
export * from "./FatherBreederInput.vue?vue&type=script&lang=js"

import "./FatherBreederInput.vue?vue&type=style&index=0&id=059b1228&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059b1228"]])

export default __exports__